import { render, staticRenderFns } from "./subcategories.vue?vue&type=template&id=3148f0d7&scoped=true&"
import script from "./subcategories.vue?vue&type=script&lang=js&"
export * from "./subcategories.vue?vue&type=script&lang=js&"
import style0 from "./subcategories.vue?vue&type=style&index=0&id=3148f0d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3148f0d7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
